import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import * as S from './EditProfileSection.styles';
import { Input } from '@/components/UI/Input/Input';
import { USER_NAME_MAX_LENGTH } from '@/constants/common';
import { HelperText } from '@/components/UI/HelperText/HelperText';
import { useEditProfileSection } from '@/features/Profile/sections/ProfileSettings/hooks';

export const EditProfileSection = () => {
  const { t } = useTranslation();
  const { control, errors, isUpdating, submitProfile } =
    useEditProfileSection();

  return (
    <S.Form onSubmit={submitProfile} noValidate>
      <S.Header>
        <S.Title>{t('pages.cabinet.profile')}</S.Title>
        <S.SubmitButton
          appearance="secondaryLight"
          type="submit"
          disabled={isUpdating}
        >
          {t('common.save_changes')}
        </S.SubmitButton>
      </S.Header>

      <S.Inputs>
        <Controller
          name="name"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              appearance="filled"
              clear={() => field.onChange('')}
              maxLength={USER_NAME_MAX_LENGTH}
              label={t('common.name')}
              helperText={fieldState.error?.message}
              hasError={!!fieldState.error}
            />
          )}
        />

        <Controller
          name="email"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              appearance="filled"
              clear={() => field.onChange('')}
              label="E-mail"
              type="text"
              inputMode="email"
              autoComplete="email"
              helperText={fieldState.error?.message}
              hasError={!!fieldState.error}
            />
          )}
        />

        {errors.root?.message && (
          <HelperText
            helperText={errors.root.message}
            hasError
            hasBottomMargin={false}
          />
        )}
      </S.Inputs>
    </S.Form>
  );
};
